export default {
  title: {
    id: 'product_reviews_block_bottom_title',
    defaultMessage: "{ title }'s customer reviews",
  },
  cta: {
    id: 'product_reviews_block_button_v2',
    defaultMessage: 'See all { count } reviews',
  },
  noReviewsForFiltersTitle: {
    id: 'product_reviews_block_no_reviews_for_filters_title',
    defaultMessage: 'No reviews found matching your filters',
  },
  noReviewsForFiltersDescription: {
    id: 'product_reviews_block_no_reviews_for_filters_description',
    defaultMessage: 'Change filters to see reviews',
  },
  resetFilters: {
    id: 'reviews_mobile_filters_reset',
    defaultMessage: 'Reset filters',
  },
  mobileReviewsTitle: {
    id: 'reviews_mobile_reviews_title',
    defaultMessage: 'Reviews',
  },
  nextReviews: {
    id: 'reviews_block_next_reviews',
    defaultMessage: 'Next reviews',
  },
  previousReviews: {
    id: 'reviews_block_previous_reviews',
    defaultMessage: 'Previous reviews',
  },
}
